import * as types from './types';

const mutations = {
  [types.SET_USER]: (state, payload) => {
    state.user = payload;
  },
  [types.RESET_USER]: (state) => {
    state.user = {
      email: '',
      password: '',
      data: {},
    };
  },
};

export default mutations;
